import { render, staticRenderFns } from "./SettingItem.vue?vue&type=template&id=51558778&scoped=true&"
import script from "./SettingItem.vue?vue&type=script&lang=js&"
export * from "./SettingItem.vue?vue&type=script&lang=js&"
import style0 from "./SettingItem.vue?vue&type=style&index=0&id=51558778&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51558778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51558778')) {
      api.createRecord('51558778', component.options)
    } else {
      api.reload('51558778', component.options)
    }
    module.hot.accept("./SettingItem.vue?vue&type=template&id=51558778&scoped=true&", function () {
      api.rerender('51558778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/setting/SettingItem.vue"
export default component.exports